var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3394_4491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4636 12.0733C24.4636 5.40541 19.0582 0 12.3902 0C5.72231 0 0.316895 5.40541 0.316895 12.0733C0.316895 18.0994 4.73191 23.0943 10.5038 24V15.5633H7.43828V12.0733H10.5038V9.41343C10.5038 6.38755 12.3063 4.71615 15.064 4.71615C16.385 4.71615 17.7666 4.95195 17.7666 4.95195V7.92313H16.2443C14.7445 7.92313 14.2767 8.85386 14.2767 9.80864V12.0733H17.6252L17.0899 15.5633H14.2767V24C20.0485 23.0943 24.4636 18.0996 24.4636 12.0733Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3394_4491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1467,
    height: 24,
    fill: "currentColor",
    transform: "translate(0.316895)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fa02adde18fe2a056625196837b366ce.svg";
export { ForwardRef as ReactComponent };